// extracted by mini-css-extract-plugin
export default {"sentenceList":"videoTranscript_sentenceList__VzDoT"};